// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"774":"94435543","956":"9695dbf0"}[chunkId] + ".chunk.js";
};